// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_COURSE_TYPES,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getCourseTypes = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('course_type')
      .then(
        (response) => {
          dispatch(GET_COURSE_TYPES, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/courseTypesActions.js